export const accountinitialState = {
    accountType: null, 
    profileData: {
      personName: '',
      balance: 0,
      exposure: 0,
      pnl: 0,
      userId: '',
      username: '',
      currency: 'INR',
    },
    bets: [],
  };